/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RemarksData } from './remarks.component.interface';
@Component({
  selector: 'remarks-component',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss']
})
export class RemarksComponent implements OnInit {
  RemarksForm = new UntypedFormGroup({
    reason : new UntypedFormControl('',Validators.required)
  });
  showButtonSpinner: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<RemarksComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemarksData){}


  ngOnInit(): void {};

  submit(): void{
    this.RemarksForm.markAllAsTouched();
    if(this.RemarksForm.valid){
      this.showButtonSpinner = true;
      this.dialogRef.close(this.RemarksForm.value);
    }

  }
}


